import { useContext } from 'react';
import { ThemeContext } from './Contexts';

import { useStore } from 'react-redux';
import G from './Getters';
export default function ThemeContextCover({style={}}){

  let store = useStore();
  let state = store.getState();
  let themeStyle = G.getActiveWorkspaceTheme(state); 


  return (
    <div class="absolute-cover npe" style={{
      zIndex:100,
      ...style,
      ...(themeStyle || {}),
    }}/>
  )

}
